import * as Sentry from '@sentry/browser'
import { calculateAppEnvironment, initGlobally } from '@wix/error-monitor'
import { tryCatchSync } from '@wix/funnel-utils'

const redact: Record<string, true> = {
  'post /chat': true,
  'post /insights': true,
}

const redactData = (event: Sentry.Event) => {
  const requestConfig = event.contexts?.httpErrorDetails?.requestConfig as Record<string, unknown> | undefined
  if (!requestConfig) {
    return
  }
  const { data } = requestConfig
  let { url, method } = requestConfig
  url = typeof url === 'string' ? url.toLowerCase() : url
  method = typeof method === 'string' ? method.toLowerCase() : method
  const key = `${method} ${url}`
  if (data && redact[key]) {
    requestConfig.data = '<redacted>'
  }
  return event
}

type Integrations = Parameters<typeof initGlobally>[0]['integrations']
type Integration = Extract<Integrations, unknown[]>[number]

const removeTrashEvents: Integration = {
  name: 'RemoveTrash',
  setupOnce: addGlobalEventProcessor => {
    addGlobalEventProcessor(event => {
      const value = event.exception?.values?.[0]
      if (value && value.type === 'UnhandledRejection' && !value.stacktrace) {
        return null
      }
      return event
    })
  },
}

export const errorMonitor = initGlobally({
  Sentry,
  environment: calculateAppEnvironment(),
  // TODO: remove default once GA is finished
  appName: window.__ARTIFACT_NAME__ || 'funnel-intro-viewer',
  version: window.__ARTIFACT_VERSION__,
  // TODO: remove default once GA is finished
  dsn: window.__SENTRY_DSN__ || 'https://5b788b3a5df445bb8a700a605df24376@sentry-next.wixpress.com/23862',
  user: { id: window.__USER_ID__ },
  beforeSend: event => {
    tryCatchSync(() => redactData(event))
    return event
  },
  integrations: [
    removeTrashEvents,
    new Sentry.Integrations.InboundFilters({
      ignoreErrors: [
        'conductExperiment?key=specs.fedinfra.Glassbox',
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications.',
        'logMutedMessage',
        'Permission denied to access property "unlock"',
        'Could not establish connection. Receiving end does not exist.',
        'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target',
      ],
      denyUrls: [
        /^(chrome|moz)-extension:\/\//,
        /safari-(web-)?extension/,
        /^webpack-internal:\/\//,
        /^\/\/hidden\//,
        /^<anonymous>/,
      ],
    }),
  ],
})

const globalContext: Record<string, string> = {}
export const addGlobalContext = (key: string, value: string) => {
  globalContext[key] = value
  Sentry.setContext('global', globalContext)
}
